export const otpEndPointMerchant = 'Merchant/ConfirmOTP';
export const otpEndPointBuyer = 'Buyer/ConfirmOTP';
export const otpEndPoint = 'Account/ConfirmOTP';

export const otp = 'otp';
export const guid = 'guid';
